<template>
  <div class="main_order">
    <!-- 快捷查询 -->
    <div
      style="display: flex;align-items: center;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);border: 1px solid #EBEEF5;border-radius: 4px;padding:15px;margin-bottom: 15px;">
      <span>快捷查询：</span>
      <el-radio-group v-model="orderContractStatus" @change="handleOrderContractStatusChange">
        <el-radio-button :label="null">全部</el-radio-button>
        <el-radio-button :label="1">待确认货源（{{ $store.state.toConfirmGoodSource.num }}）</el-radio-button>
        <el-radio-button :label="10">待发货（{{ $store.state.toDelivery.num }}）</el-radio-button>
        <el-radio-button :label="2">超时确认货源（{{ $store.state.overConfirmGoodSource.num }}）</el-radio-button>
        <el-radio-button :label="3">超72小时未反馈物流（{{ $store.state.over72Hours.num }}）</el-radio-button>
      </el-radio-group>
    </div>
    <el-form :model="subForm" label-width="100px" class="el-form-box">
      <el-row>
        <el-col :span="6">
          <el-form-item label="订单号">
            <el-input v-model="subForm.SearchKey" placeholder="请输入订单号，多个以,隔开"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品名称">
            <el-input v-model="subForm.ProductName" placeholder="请输入商品名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品spuId">
            <el-input v-model="subForm.SpuId" placeholder="请输入商品名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收货人姓名">
            <el-input v-model="subForm.ReceiverName" placeholder="请输入收货人姓名"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="收货人电话">
            <el-input v-model="subForm.ReceiverPhone" placeholder="请输入收货人电话"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="分销商">
            <el-select v-model="subForm.SupId" filterable remote :remote-method="remoteReseller" placeholder="分销商"
              style="width:100%;">
              <el-option v-for="(item, index) in resellerList" :key="index" :label="item.value"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单状态">
            <el-select v-model="subForm.OrderStatus" placeholder="请选择">
              <el-option :value="0" label="全部"></el-option>
              <el-option :value="10" label="待付款"></el-option>
              <el-option :value="20" label="备货中"></el-option>
              <el-option :value="30" label="待收货"></el-option>
              <el-option :value="40" label="已收货"></el-option>
              <el-option :value="50" label="已完成"></el-option>
              <el-option :value="60" label="已取消"></el-option>
              <el-option :value="70" label="已关闭"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="采购信息">
            <el-select v-model="subForm.IsHasBuy">
              <el-option :value="-1" label="全部"></el-option>
              <el-option :value="1" label="是"></el-option>
              <el-option :value="0" label="否"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="下单时间">
            <el-date-picker v-model="value1" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker1"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="完成时间">
            <el-date-picker v-model="value2" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker2"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="支付时间">
            <el-date-picker v-model="value4" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker4"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="操作发货时间">
            <el-date-picker v-model="value3" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker3"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="品牌">
            <el-autocomplete @clear="clearBrand" clearable v-model="brandName" :fetch-suggestions="querySearchAsync6"
              placeholder="请选择品牌" @select="handleSelect6"></el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="类型">
            <el-cascader clearable @change="changeCascader" v-model="typeIds" ref="typeCascader"
              :props="{ value: 'id', label: 'typeName', children: 'childrens', checkStrictly: true, }"
              :show-all-levels="false" :options="productNavTypeTreeList" placeholder="请选择类型"></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="未发货时效">
            <el-select v-model="subForm.UnShipType">
              <el-option :value="null" label="全部"></el-option>
              <el-option :value="1" label="24小时内未发货"></el-option>
              <el-option :value="2" label="超24小时未发货"></el-option>
              <el-option :value="3" label="超48小时未发货"></el-option>
              <el-option :value="4" label="超72小时未发货"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="履约状态查询">
            <el-select v-model="subForm.OrderContractStatus">
              <el-option :value="null" label="全部"></el-option>
              <el-option :value="1" label="待确认货源"></el-option>
              <el-option :value="2" label="超时确认货源"></el-option>
              <el-option :value="3" label="超72小时未反馈物流"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item>
            <el-button type="primary" @click="onSubmit">筛选</el-button>
            <el-button @click="onEmpty">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="tool_box">
      <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
      <el-button type="primary" @click="handleImport">导入物流信息</el-button>
      <el-button type="primary" @click="exportBtn">导出</el-button>
      <el-button type="primary" @click="batchTakingOrder">批量接单</el-button>
      <el-button type="primary" @click="explainShow = !explainShow" class="explain-btn">操作说明<i
          :class="explainShow ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i></el-button>
    </div>
    <div class="explain" v-if="explainShow">
      <p>操作说明：</p>
      <p>1.接单：点击后订单会被标记为已接单状态，用于确认该订单是否被您的上游供应商采购或提交等场景自行记录使用；</p>
      <p>2.发货：输入物流信息进行订单发货，订单状态将变更为待收货状态，即已发货；</p>
      <p>3.备注：可针对该订单进行备注记录，用于该订单存在特殊事项的自行记录场景，以便后续查阅；</p>
    </div>
    <el-card style="margin-top: 15px">
      <el-table :data="orderList" border style="width: 100%;" ref="multipleTable"
        @selection-change="handleSelectionChange" v-loading="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
        :span-method="arraySpanMethod" :cell-class-name="setCellStyle">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="子订单号" align="center" min-width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.childOrderNo }}</div>
            <div>
              <el-tag size="mini" type="danger" v-if="scope.row.isHaveExecingAfter">有进行中售后</el-tag>
              <div v-if="[1, 2].includes(scope.row.PromoteTag)">结束后发货时效: {{scope.row.PromoteDeliveryTimeTag && tagArray[scope.row.PromoteDeliveryTimeTag]}}, {{scope.row.PromoteTag == 1 ? '预售' : '抢单'}}结束时间:{{ scope.row.PromoteEndTime }}</div>
              <!-- <el-tooltip v-if="!loading"
                :content="`结束后发货时效: ${scope.row.PromoteDeliveryTimeTag && tagArray[scope.row.PromoteDeliveryTimeTag]}, ${scope.row.PromoteTag == 1 ? '预售' : '抢单'}结束时间:${scope.row.PromoteEndTime}`"
                placement="bottom" effect="light">
                <el-tag v-if="scope.row.PromoteTag == 1" effect="dark" type="danger" style="margin-left: 10px"
                  size="mini">
                  <span>预售</span>
                </el-tag>

                <el-tag v-if="scope.row.PromoteTag == 2" effect="dark" type="danger" style="margin-left: 10px"
                  size="mini">
                  <span>抢单</span>
                </el-tag>
              </el-tooltip> -->
              <el-button type="primary" size="mini"
                v-if="isEditPresaleTime && scope.row.PromoteTag == 1 || scope.row.PromoteTag == 2"
                style="padding:4px 5px;margin-left:5px;" @click="editPresaleTime(scope.row)">修改预售时间</el-button>
              <p style="font-size:12px;" v-if="scope.row.confirmSourceType">[确认货源]{{ scope.row.confirmSourceType }}{{
                scope.row.confirmSourceValue }}</p>
              <div v-if="scope.row.oldId">
                <el-tag size="mini" type="danger">补单订单，无需发货</el-tag>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="物流信息" align="center" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.spuLogisticsList[0]">
              <div class="logStyle" v-for="(log, logId) in scope.row.spuLogisticsList[0].childLogistics" :key="logId"
                @click="handleLogistics(log)">
                <div style="display:flex;justify-content:space-between;">
                  <div>
                    {{ log.logisticsCompanyName }}{{ log.logisticsCode }} <p style="color:#F56C6C;"
                      v-show="log.isCheckSign">（签收
                      {{ log.signTime }}）</p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" align="center" width="400">
          <template slot-scope="scope">
            <div style="text-align: left;">商品名称：{{ scope.row.skuName }}</div>
            <div style="text-align: left;">规格信息：{{ scope.row.skuSpecName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="结算价格" align="center" width="160">
          <template slot-scope="scope">
            <p>单价：￥{{ scope.row.skuBillPrice }}</p>
            <p>合计：￥{{ settlePrice(scope.row) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="数量" align="center">
          <template slot-scope="scope">
            {{ getSkuNumber(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="用户留言" align="center"></el-table-column>
        <el-table-column label="收货信息" align="center" width="300">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 20 || scope.row.status == 30">
              <p>{{ scope.row.receiverName }}--{{ scope.row.receiverPhone }}</p>
              <p>
                {{ scope.row.receiverProvinceName }} -
                {{ scope.row.receiverCityName }} -
                {{ scope.row.receiverDistrictName }} -
                {{ scope.row.receiverStreetName }} -
                {{ scope.row.receiverAddress }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 10">待支付</span>
            <span v-if="scope.row.status == 20">备货中</span>
            <span v-if="scope.row.status == 30">待收货</span>
            <span v-if="scope.row.status == 40">已收货</span>
            <span v-if="scope.row.status == 50">已完成</span>
            <span v-if="scope.row.status == 60">已取消</span>
            <span v-if="scope.row.status == 70">已关闭</span>
          </template>
        </el-table-column>
        <el-table-column prop="supplierName" label="商品供应商" align="center"></el-table-column>
        <el-table-column label="时间" align="center" width="300">
          <template slot-scope="scope">
            <div>
              <p v-if="scope.row.createTime">
                下单时间：{{ scope.row.createTime }}
              </p>
              <p v-if="scope.row.shipTime">
                发货时间：{{ scope.row.shipTime }}
              </p>
              <p v-if="scope.row.receiveTime">
                收货时间：{{ scope.row.receiveTime }}
              </p>
              <p v-if="scope.row.completeTime">
                完成时间：{{ scope.row.completeTime }}
              </p>
              <p v-if="scope.row.refundTime">
                退款时间：{{ scope.row.refundTime }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="报装信息" align="center" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.isInstall">
              <p>{{ scope.row.installPushNo }}</p>
              <p>报装台数：{{ scope.row.installNumber }}</p>
              <div class="demo-image__preview" v-if="scope.row.installPic">
                <el-image style="width: 50px; height: 50px;margin-right:10px;" v-for="(item, index) in scope.row.installPic.split(',')"
                  :key="index" :src="item" :preview-src-list="scope.row.installPic.split(',')" @click.stop="handleImgClose">
                </el-image>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="220">
          <template slot-scope="scope">
            <el-button @click="handleDetail(scope.row)" type="primary" size="small">详细
            </el-button>
            <el-button type="primary" size="small" v-preventClick
              v-if="scope.row.spuLogisticsList[0] && scope.row.spuLogisticsList[0].canSendNumber > 0"
              @click="fahuo(scope.row.spuLogisticsList[0], scope.row)">发货
            </el-button>
            <el-button type="primary" size="small" v-preventClick @click="takingOrder(scope.row.childOrderId)"
              v-if="!scope.row.isErpRecepted">接单
            </el-button>
            <el-button type="primary" size="small" @click="handlRemark(scope.row)">备注</el-button>
            <el-button @click="confirmSource(scope.row)" type="success" size="small"
              v-if="scope.row.status == 20 && !scope.row.confirmLogisticsName && scope.row.spuLogisticsList[0].sendSkuNumber == 0">确认货源</el-button>
            <!-- <el-button @click="selectDelivery(scope.row)" type="success" size="small"
              v-if="scope.row.status == 20">承运物流</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"
        @current-change="handleCurrentChange" style="float: right;margin: 10px 0;"></el-pagination>
    </el-card>
    <!-- 发货 -->
    <el-dialog title="发货" :visible.sync="dialogVisible" width="40%" :close-on-click-modal="false" class="orderDialog">
      <p style="color:red;margin-bottom: 15px;">*注意:自备仓开单需在24小时内反馈发货情况，非自备仓开单需在48小时内。</p>
      <el-form ref="logForm" :model="logForm" label-width="100px" label-position="left"
        style="background: #fff;border-radius: 10px;padding:25px 15px;">
        <el-radio-group v-model="typeRadio"
          style="margin-bottom: 25px;border-bottom:1px solid #F0F4FC;padding-bottom:25px;width:100%;">
          <el-radio :label="1">已发货但还没单号</el-radio>
          <el-radio :label="2">已发货有单号</el-radio>
        </el-radio-group>
        <el-form-item label="选择物流公司" v-if="typeRadio == 1">
          <el-select v-model="logisticsCompanyId" filterable remote placeholder="请输入关键词"
            @change="onLogisticsCompanyChange" :remote-method="getLogisticsCompany" clearable style="width:100%;">
            <el-option v-for="item in logisticsCompanyData" :key="item.id" :label="item.fullName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" v-if="typeRadio == 1">
          <p style="color:red;position: relative;left:-100px;">*注:一旦选择物流公司，则默认已发货，如果发现是虚假发货，则需扣除订单总金额的20%作为罚款。</p>
        </el-form-item>
        <el-form-item label="供应商" v-show="typeRadio == 2">
          <span>{{ tempData.buySupplierName }}</span>
        </el-form-item>
        <el-form-item label="选择物流公司" v-show="typeRadio == 2">
          <el-select v-model="logForm.logisticsCompanyId" filterable placeholder="请选择物流公司">
            <el-option v-for="(item, index) in logisticsList" :key="index" :label="item.shortName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号" v-show="typeRadio == 2">
          <el-input class="flex-1" placeholder="输入物流单号，只允许填写一个物流单号" v-model="logForm.logisticsCode"
            @input="logisticsInput" @change="getLogisticsByNumber">
          </el-input>
        </el-form-item>
        <el-form-item label="当前发货数量" v-show="typeRadio == 2">
          <el-input v-model="logForm.sendSkuNumber" @input="watchInput"></el-input>
          <span style="margin-left: 30px">已发货{{ tempData.sendSkuNumber }}</span>
          <span style="margin-left: 30px">未发货{{ tempData.canSendNumber }}</span>
        </el-form-item>
        <el-form-item label="外部订单号" v-show="typeRadio == 2">
          <el-input v-model="logForm.outchildOrderNo"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-preventClick :disabled="clickDisabled" @click="handleSendSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 退款 -->
    <el-dialog title="退款" :visible.sync="returnVisible" width="40%" :close-on-click-modal="false">
      <el-form label-width="140px" style="background: none">
        <el-form-item label-width="0" v-if="fullReduceData.isJoinChannelFullReduceActivity &&
          fullReduceData.tipsMessage
        ">
          <span style="color: #f40000">{{ fullReduceData.tipsMessage }}</span>
        </el-form-item>
        <el-form-item label-width="0" v-if="fullReduceData.isJoinChannelFullReduceActivity &&
          fullReduceData.deductDiscountAmount
        ">
          <span style="color: #f40000">该商品参加满减活动，退款后该主订单金额不满足满减条件，需扣除优惠金额</span>
        </el-form-item>
        <el-form-item label="订单实付金额:">
          <span>￥{{ fullReduceData.actualPayAmount }}</span>
        </el-form-item>
        <el-form-item label="订单金额：" v-if="fullReduceData.isJoinChannelFullReduceActivity">
          <span>￥{{ fullReduceData.orderAmount }}</span>
        </el-form-item>
        <el-form-item label="购买数量:">
          <span>{{ receiveRow.skuNumber }}</span>
        </el-form-item>
        <el-form-item label="退款数量:">
          <span>{{ fullReduceData.applySkuNumber }}</span>
        </el-form-item>
        <el-form-item label="需扣除的优惠金额：" v-if="fullReduceData.isJoinChannelFullReduceActivity">
          <span>￥{{ fullReduceData.deductDiscountAmount }}</span>
        </el-form-item>
        <el-form-item label="实际退款金额:">
          <span>￥{{ fullReduceData.actualRefundAmount }}</span>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="returnForm.reason" placeholder="请输入备注内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="returnVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleReturnSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 物流信息 -->
    <el-dialog title="物流信息" width="50%" :visible.sync="logVisible" :close-on-click-modal="false">
      <div v-for="(item, index) in logDescriptionList" class="item_li" :key="index">
        <span>{{ item.description }}</span>
        <span>{{ item.time }}</span>
      </div>
    </el-dialog>
    <!-- 上传文件弹窗 -->
    <el-dialog title="导入采购信息" width="30%" :visible.sync="purImpVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataPur"
          :on-remove="removePur">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo(1)">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleExpSubmit(1)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入物流信息 -->
    <el-dialog title="导入物流信息" width="60%" :visible.sync="logisticsVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics"
          :on-remove="removeLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo(2)">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <div style="color:#666;font-size:12px;width:80%;margin:15px auto 0;">
        <p style="font-size:16px;color:#333;margin-bottom: 5px;font-weight:bold;">导入案例与注意事项:</p>
        <p>1.导入物流发货的订单<span style="color:red">必须先确认货源才可导入；</span></p>
        <p>2.可以<span style="color:red">只导入确认货源</span>，不导入物流信息。导入确认货源时按照订单所需，正确填写图上所示列的类型<span
            style="color:Red;">（已开单的类型需填写预计送达时间）</span>，不可填错，若需补货，需填写预计补货时间，时间按照图上示列规范填写。<span
            style="color:red">单独导入确认货源时，发货数量需填0；</span></p>
        <p>3.可以合并导入物流信息和确认货源，<span style="color:red">合并导入时发货数量则不可为0，</span>需正常填写发货数量</p>
        <img src="https://ksaximg.ksaxshop.com/erp/20260203-193324.jpg" style="width:100%;margin-top:10px;">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit(2)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 退款/退货数量 -->
    <el-dialog width="30%" center :visible.sync="dialogSkuNumber" :close-on-click-modal="false">
      <div style="text-align: center">
        <span style="margin-right: 10px">退款数量:</span>
        <el-input v-model.number="needData.applySkuNumber" @input="watchApplySkuNumber"></el-input>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="confirmBtn">确认</el-button>
        <el-button @click="dialogSkuNumber = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 导入物流报错信息 -->
    <el-dialog :visible.sync="dialogMsgVisible">
      <ul>
        <li style="margin: 10px 0; border-bottom: 1px solid #999" v-for="(item, index) in msgList" :key="index">
          {{ item.Message }}
        </li>
      </ul>
    </el-dialog>
    <!-- 修改收货信息 -->
    <el-dialog width="80%" title="修改收货信息" :visible.sync="addressShowDialog" :close-on-click-modal="false">
      <el-table border :data="addressList" stripe style="width: 100%">
        <el-table-column prop="childOrderNo" label="订单号" width="210" align="center">
        </el-table-column>
        <el-table-column prop="receiverName" label="收货人" width="100" align="center">
        </el-table-column>
        <el-table-column prop="receiverPhone" label="电话" width="120" align="center"></el-table-column>
        <el-table-column prop="address" label="收货地址" width="300" align="center">
          <template slot-scope="scope">
            {{ scope.row.receiverProvinceName }}-{{
              scope.row.receiverCityName
            }}-{{ scope.row.receiverDistrictName }}-{{
              scope.row.receiverStreetName
            }}-{{ scope.row.receiverAddress }}
            <el-button type="primary" icon="el-icon-document-copy" circle @click="handleCopy(scope)"></el-button>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="修改收货人" width="120" align="center">
          <template slot-scope="scope">
            <el-input style="width: 100px" v-model="scope.row.name"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="修改收货电话" width="140" align="center">
          <template slot-scope="scope">
            <el-input style="width: 120px" maxlength="11" v-model="scope.row.phone"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="address" min-width="700" label="修改收货地址" align="center">
          <template slot-scope="scope">
            <el-form :inline="true">
              <el-form-item>
                <el-select v-model="scope.row.provinceName" placeholder="省" @change="handleProvince($event, scope)"
                  style="width: 150px">
                  <el-option v-for="item in provinceList" :key="item.Id" :label="item.AreaName" :value="item.Id">
                  </el-option>
                </el-select>
                <el-select v-model="scope.row.cityName" placeholder="市" @change="handleCity($event, scope)"
                  style="width: 150px">
                  <el-option v-for="item in cityList" :key="item.Id" :label="item.AreaName" :value="item.Id">
                  </el-option>
                </el-select>
                <el-select v-model="scope.row.districtName" placeholder="区" @change="handleArea($event, scope)"
                  style="width: 150px">
                  <el-option v-for="item in areaList" :key="item.Id" :label="item.AreaName" :value="item.Id">
                  </el-option>
                </el-select>

                <el-select v-model="scope.row.streetName" placeholder="街道" @change="handleStreet($event, scope)"
                  style="width: 150px">
                  <el-option v-for="item in streetList" :key="item.Id" :label="item.AreaName" :value="item.Id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input v-model="scope.row.address" style="width: 150px"></el-input>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button type="primary" @click="handleConfirmBtn">确认</el-button>
        <el-button @click="addressShowDialog = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog title="修改物流" :visible.sync="reviseVisible" width="30%" :close-on-click-modal="false">
      <el-form ref="reviseForm" :model="reviseForm" label-width="120px" style="background: none">
        <el-form-item label="物流公司">
          <el-select v-model="reviseForm.logisticsCompanyId" filterable placeholder="请选择物流公司">
            <el-option v-for="(item, index) in logisticsList1" :key="index" :label="item.ShortName"
              :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input v-model="reviseForm.logisticsCode"></el-input>
        </el-form-item>
        <!-- <el-form-item label="发货数量">
          <span>{{tempData.canSendNumber}}</span>
        </el-form-item> -->
        <el-form-item label="当前发货数量">
          <el-input v-model="reviseForm.sendSkuNumer"></el-input>
        </el-form-item>
        <el-form-item label="外部订单号">
          <el-input v-model="reviseForm.outchildOrderNo"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reviseVisible = false">取 消</el-button>
        <el-button type="primary" v-preventClick @click="handleReviseSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量审批导入" :visible.sync="approveBatch" width="30%" :before-close="approveClose"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataApprove"
          :on-remove="removeApprove">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xlsx文件
            <el-button type="text" @click="upDataInfo(3)">下载导入模板</el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="approveClose">取 消</el-button>
        <el-button type="primary" @click="approveSure">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量修改收货地址 -->
    <el-dialog title="批量修改收货地址" width="30%" :visible.sync="dialogEidtAddress" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics"
          :on-remove="removeLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo(4)">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit(4)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 备注 -->
    <el-dialog title="备注" :visible.sync="remarkVisible" width="60%" :before-close="remarkClose">
      <el-form :model="remarkForm" label-width="80px">
        <el-form-item label="备注信息">
          <el-input type="textarea" v-model="remarkForm.Description" placeholder="备注信息"
            :autosize="{ minRows: 4 }"></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <div style="display: inline-block" class="img_box1" v-for="(item, index) in UploadFileUrl">
            <p class="del_box" @click.stop="handleDelPic(index)">
              <img src="../../assets/del-icon.png" alt />
            </p>
            <img :src="item" alt @click.stop="handleBigPic(item)" />
          </div>
          <el-upload style="display: inline-block" class="avatar-uploader" action :show-file-list="false"
            :auto-upload="false" :on-change="handleBusinessPic">
            <i class="el-icon-plus avatar-uploader-icon plus-sign"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-table :data="remarkTableData" style="width: 100%" border :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }">
        <el-table-column prop="description" label="备注信息" />
        <el-table-column label="图片">
          <template slot-scope="scope">
            <img :src="item" v-for="(item, index) in scope.row.images"
              style="width: 100px;margin-left:15px;margin-top:15px">
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="提交时间" />
      </el-table>
      <span slot="footer">
        <el-button @click="remarkClose">取 消</el-button>
        <el-button type="primary" @click="remarkConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改预售时间 -->
    <el-dialog title="修改预售时间" width="30%" :visible.sync="dialogEidtPresaleTime" :show-file-list="false"
      :close-on-click-modal="false">
      <el-form label-width="100px">
        <el-form-item label="选择时间">
          <el-date-picker v-model="presaleDateTime" type="datetime" placeholder="选择日期" style="width:100%;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleEditPresaleTime">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 确认货源 -->
    <el-dialog title="确认货源" :visible.sync="confirmSourceVisible" width="50%" :close-on-click-modal="false"
      class="orderDialog">
      <el-form label-width="30px" style="background: none">
        <el-form-item>
          <div style="color:red;font-size: 16px;line-height: 1.8;">
            注意:<span class="bold">16点前订单</span>，需在<span class="bold">明天17点前</span>反馈货源情况。<span
              class="bold">16点后订单</span>，需在<span class="bold">后天中午12点</span>前反馈。超时未反馈，则按照<span
              @click="confirmSourceRuleVisible = true"
              style="color:#409EFF;cursor:pointer;text-decoration: underline;">平台履约制度</span>对商户进行补券。
          </div>
        </el-form-item>
        <el-form-item>
          <div style="background: #fff;border-radius: 10px;padding: 10px 20px;margin-bottom: 15px;">
            <p style="font-weight:bold;font-size: 16px;">有货：</p>
            <div class="flex">
              <el-radio v-model="sourceType" :label="2">非自备仓开单</el-radio>
              <p style="color:red;">(*注意:非自备仓开单需在72小时内反馈物流)</p>
            </div>
            <div class="flex">
              <el-radio v-model="sourceType" :label="3">自备仓开单</el-radio>
              <p style="color:red;">(*注意:自备仓开单需在24小时内反馈物流)</p>
            </div>
            <div class="flex">
              <el-radio v-model="sourceType" :label="5">
                <span style="margin-right:15px;">已开单&nbsp;&nbsp;&nbsp;&nbsp;预计送达时间</span>
                <el-date-picker v-model="timeValue1" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                  :disabled="sourceType != 5">
                </el-date-picker>
              </el-radio>
            </div>
          </div>
          <div style="background: #fff;border-radius: 10px;padding: 10px 20px;">
            <p style="font-weight:bold;font-size: 16px;">无货：</p>
            <div class="flex">
              <el-radio v-model="sourceType" :label="1">
                <span style="margin-right:15px;">预计补货时间：最晚不超过</span>
                <el-date-picker v-model="timeValue" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                  :disabled="sourceType != 1" :picker-options="pickerOptions">
                </el-date-picker>
              </el-radio>
            </div>
            <div class="flex">
              <div>
                <el-radio v-model="sourceType" :label="4">无货劝退</el-radio>
                <span style="color:red;">(*注意:无货劝退并自动区域限购)</span>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmSourceVisible = false">取 消</el-button>
        <el-button type="primary" v-preventClick :disabled="clickDisabled" @click="handleSetSource">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看履约制度 -->
    <el-dialog title="关于异常订单给予客户补偿的标准" center :visible.sync="confirmSourceRuleVisible" width="35%"
      :close-on-click-modal="false">
      <div style="padding:0 30px;text-indent: 2em;">
        为了提高客户满意率，增加客户与平台粘性，提高复购活跃率；针对异常订单：发货超72H（未提前告知客户）的订单、以及无货退款订单，给予客户一定的券额补偿（使用规则：无门槛/有效期7天）。<br /><br />
        <span style="font-weight:bold">一、订单状态定义：</span><br /><br />
        1、预售订单：<span style="color:red;">标题/产品详情预售及预售发货周期</span>提示；<br />
        2、节点订单：供应商有采购节点要求，指限定时间内开放政策进行采购，标题有采购<span style="color:red;">开单节点时间/发货周期</span>提示；<br />
        3、正常订单：除以上两种状态外的订单；<br /><br />
        二、24小时内无货劝退，时效内反馈，供应商免责，但需对无货区域进行限购或下架处理； 72小时超时未发订单，时效内反馈具体到货时间，供应商免责，但多次更改发货时间，需补券<br /><br />

        <span style="font-weight:bold">三、＞24小时劝退<span style="color:red;">正常订单</span>供应商补偿标准：</span><br /><br />
        1、补偿标准：<br />
        订单金额：订单金额≤1000元=10元券<br />
        订单金额：1000元＜订单金额≤3000元=20元券<br />
        订单金额：3000元＜订单金额≤5000元=30元券<br />
        订单金额：5000元＜订单金额≤8000元=50元券<br />
        订单金额：8000元＜订单金额≤10000元=80元券<br />
        订单金额：订单金额＞10000元=100元券<br /><br />
        <span style="font-weight:bold">四、超72小时未发货供应商补偿：</span><br /><br />
        1、补偿标准：<br />
        订单金额：订单金额≤1000元=10元券<br />
        订单金额：1000元＜订单金额≤3000元=20元券<br />
        订单金额：3000元＜订单金额≤5000元=30元券<br />
        订单金额：5000元＜订单金额≤8000元=50元券<br />
        订单金额：8000元＜订单金额≤10000元=80元券<br />
        订单金额：订单金额＞10000元=100元券<br /><br />

        补偿费用均从供应商当期货款中扣除。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSourceRuleVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 承运物流 -->
    <!-- <el-dialog title="承运物流" :visible.sync="deliveryVisible" width="40%" :close-on-click-modal="false">
      <el-form label-width="90px" style="background: none">
        <el-form-item label="物流公司">
          <el-select v-model="logisticsCompanyId" filterable remote placeholder="请输入关键词"
            @change="onLogisticsCompanyChange" :remote-method="getLogisticsCompany" clearable style="width:100%;">
            <el-option v-for="item in logisticsCompanyData" :key="item.id" :label="item.fullName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deliveryVisible = false">取 消</el-button>
        <el-button type="primary" v-preventClick :disabled="clickDisabled" @click="handleDelivery">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import toolbar from "../../components/Toolbar";
import autocomplete from "../../components/autocomplete";
import countDown from "../../components/countDown.vue";
import {
  KSAXApiRequest,
  GetAllReseller,
  KSAXApiUpload,
  GetOrderLogisticsKSAX,

  subOrderList,
  setExceptional,
  cancelExceptional,
  modifyLogistics,
  receipt,
  logisticsCompanyAllList,
  applyRefund,
  logistics,
  purImport,
  orderLogisticsImport,
  childListExport,
  operateExport,
  busSupplierList,
  PushJHOrder,
  StarOrder,
  CalculateRefundAmount,
  GetBalanceCanRefundNum,
  GetShipSupList,
  ChildSupShip,
  areaList,
  GetModifyReceiverAddressOrderInfo,
  ModifyReceiverAddress,
  AreaStarList,
  GetMeidiOrder,
  BindThireadOrderInfo,
  GetHxRecordInfo,
  GetAuxRecordInfo,
  HxTaskSendOrder,
  ReHxSendOrder,
  AuxTaskSendOrder,
  ReAuxSendOrder,
  GetMideaRecordInfo,
  GetMideaRecordInfo_SSX,
  GetMideaRecordInfo_SSXAC,
  MideaTaskSendOrder,
  MideaTaskSendOrder_SSX,
  MideaTaskSendOrder_SSXAC,
  ReMideaSendOrder,
  ReMideaSendOrder_SSX,
  ReMideaSendOrder_SSXAC,
  GetSNYHRecordInfo,
  SNYHTaskSendOrder,
  ReSNYHSendOrder,
  InfoDelete,
  KsaxErpOrder,
  BatchJDOrder,
  BatchRefundStatistics,
  BatchApplyRefund,
  ImportApplyRefund,
  BatchERPBackOrder,
  SwitchPurchaseSup,
  JDOrder,
  JDOrderWs,
  JDCtpOrder,
  getQiniuToken,
  ANNTOTaskSendOrder,
  GetANNTORecordInfo,
  ImportUpdateAddress,
  ReTCLTaskSendOrder,
  GetTCLRecordInfo,
  TclAreaList,
  LrlzOrder, reviseLogistics, DeleteLogistics, PrincipalUserList, PartnerList, productNavTypeTree, getBrandListPage,
  RetailExportList,
  UpdatePresaleTime,
  ChildOrderExportFinanceList
} from "../../api/api";
import { Loading } from 'element-ui';
import { number } from "echarts/lib/export";

export default {
  components: { toolbar, autocomplete, countDown },
  data() {
    return {
      brandName: '',
      typeList: [],
      typeIds: null,
      tagArray: ['暂无时效设置', '24小时', '48小时', '72小时', '4天', '5天', '6天', '7天'],
      AffiliatedCopartnerName: '',
      AffiliatedCopartnerList: [],
      //修改物流
      reviseVisible: false,
      showLogVisible: false,
      reviseForm: {
        orderLogisticsId: 0,
        logisticsCompanyId: null,
        logisticsCode: "",
        sendSkuNumer: null,
        outChildOrderNo: null
      },
      logisticsList1: [],
      dialogStarVisible: false,
      fileList: [],
      subForm: {
        BrandId: null,
        TypeId: null,
        // AffiliatedCopartnerId: null,
        SearchType: 1,
        SupId: null,
        SearchKey: null, //'2021070110010724485301',
        ProductName: null,
        ReceiverName: null,
        ReceiverPhone: null,
        UserParentName: null,
        ProductSupplier: null,
        OrderStatus: 0,
        PayType: -1,
        SpuId: null,
        OrderTimeStart: (() => {
          let date = new Date()
          if (this.$route.query.LCCWRecordId) {
            return ''
          } else {
            return this.$utils.filterDate(
              new Date(date.getTime() - 3600 * 1000 * 24 * 30)
              // new Date(new Date(new Date().toLocaleDateString()).getTime())
            )
          }
        })(),
        OrderTimeEnd: (() => {
          let date = new Date()
          if (this.$route.query.LCCWRecordId) {
            return ''
          } else {
            return this.$utils.filterDate(new Date(date.getTime() + 3600 * 1000 * 24))
            // return this.$utils.filterDate(new Date(new Date().getTime()))
          }
        })(),
        CompleteTimeStart: null,
        CompleteTimeEnd: null,
        PayTimeStart: null,
        PayTimeEnd: null,
        ShipTimeStart: null,
        ShipTimeEnd: null,
        IsExceptional: -1,
        IsHasBuy: -1,
        IsHasLogistics: -1,
        BuySupplier: null,
        Plate: -1,
        RewardType: null,
        IsSeparate: null,
        IsFirstOrder: null,
        UserType: null,
        IsDFSOrder: null,
        LogisticsNo: null,
        PageIndex: 1,
        PageSize: 10,
        UnShipType: this.$route.query.unShipType ? Number(this.$route.query.unShipType) : null,
        OrderContractStatus: null
      },
      orderContractStatus: null,
      uploading: false,
      total: 0,
      loading: true,
      logisticsList: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      orderList: [],
      multipleTable: [],
      listLoading: true,
      //   筛选条件日期
      value1: (() => {
        let date = new Date()
        if (this.$route.query.LCCWRecordId) {
          return []
        } else {
          return [
            // new Date(new Date(new Date().toLocaleDateString()).getTime()),
            new Date(date.getTime() - 3600 * 1000 * 24 * 30),
            new Date(date.getTime() + 3600 * 1000 * 24),
          ]
        }
      })(),
      value2: null,
      value3: null,
      value4: null,
      isShowDetail: false,
      isShowJD: false,
      isShowSend: false, //权限判断发货
      isShowConfirm: false, //权限判断确认收货
      isShowRefund: false, //权限判断退款
      dialogVisible: false, //发货面板开关
      returnVisible: false, //退款面板开关
      //   发货字段
      logForm: {
        childOrderId: 0,
        logisticsCompanyId: null,
        logisticsCode: "",
        buySupplierId: null,
        sendSkuNumber: null,
        outChildOrderNo: null,
      },
      typeRadio: null,
      //退款字段
      returnForm: {
        childOrderId: 0,
        refundAmount: 0,
        reason: "",
        applySkuId: 0,
        applySkuNumber: 1,
      },
      receiveRow: {},
      purImpVisible: false,
      logVisible: false,
      logisticsVisible: false,
      logDescriptionList: [],

      filePur: null,
      fileLog: null,
      fileApprove: null,
      supmodelData: {
        name: "",
        restaurants: [],
      },
      isShowStar: false,
      isShowLrlz: false,
      isDeliveryDelete: false,
      isDeliveryEdit: false,
      fullReduceData: {},
      balanceCanRefundNum: 1,
      dialogSkuNumber: false,
      needData: {
        operateType: 1,
        childOrderNo: null,
        applySkuNumber: 1,
      },
      gridData: [],
      tempData: {},
      msgList: [],
      dialogMsgVisible: false,
      clickDisabled: false,
      isShowSetAddress: false,
      addressShowDialog: false,
      isExchangePick: false,
      addressList: [],
      provinceList: [], //省
      cityList: [], //市
      areaList: [], //区
      streetList: [], //街道
      starProvinceList: [],
      starCityList: [],
      starAreaList: [],
      starAddresData: {
        provinceId: null,
        cityId: null,
        districtId: null,
        childOrderId: null
      },
      tclProvinceList: [],
      tclCityList: [],
      tclAreaList: [],
      tclStreetList: [],
      tclAddresData: {
        ksaxProvinceId: null,
        ksaxCityId: null,
        ksaxCountryId: null,
        ksaxStreetId: null,
        tclProvinceId: null,
        tclCityId: null,
        tclCountryId: null,
        tclStreetId: null,
        childOrderId: null
      },
      starProvinceCity: '',

      BindThireadOrderDialog: false,
      ThreadOrderForm: {
        childOrderId: null,
        ThirdType: null,
        ThirdOrderId: null
      },
      isSendWinShow: false,
      sendDatas: {
        // IsSend:'',
        // IsPurchaserSuccess:'',
        // IsSendSuccess:'',
        // Count:'',
      }, // 展示海信信息
      sendMsgId: null, // 推送Id
      authHaiXin: false, // 是否拥有海信推送权限
      authAux: false, // 是否拥有奥克斯推送权限
      authMedia: false, // 是否拥有，美的推送权限
      authMediaSSX: false, // 是否拥有，美的速速销推送权限
      authMediaSSXAC: false, // 是否拥有，美的速速销空调推送权限
      authSNYH: false, // 
      authADWL: false,
      authTCL: false,
      reSendData: {},
      sendLoading: false,
      sendType: 1, // 1海信推送 2奥克斯推送
      approveBatch: false,

      _tempOrder: null, // 所有用于临时存储的订单号
      dialogEidtAddress: false,

      isEditPresaleTime: false,
      dialogEidtPresaleTime: false,
      presaleOrderId: null,
      presaleDateTime: null,
      CategoryId: null,
      productNavTypeTreeList: [],
      resellerList: [],
      ResellerId: 0,
      priceType: 1,
      row: {},
      remarkVisible: false,
      remarkForm: {},
      remarkTableData: [],
      UploadFileUrl: [],
      qiniuToken: '',
      explainShow: true,

      confirmSourceVisible: false,
      sourceType: 2,
      // sourceValue: '',
      timeValue: '',
      timeValue1: '',
      orderCreatetime: null,
      confirmSourceRuleVisible: false,

      deliveryVisible: false,
      logisticsCompanyData: [],
      logisticsCompanyId: null,
      logisticsCompanyName: null,
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > (Date.now() + 15 * 24 * 3600 * 1000)
        },
      },
    };
  },
  watch: {
    '$route.query.orderContractStatus'(n, o) {
      if (n) {
        if (this.$route.query.orderContractStatus) {
          this.orderContractStatus = Number(this.$route.query.orderContractStatus)
          this.subForm.OrderContractStatus = Number(this.$route.query.orderContractStatus)
        }
        this.getResellerId()
      }
    }
  },
  created() {
    if (this.$route.query.orderContractStatus) {
      this.orderContractStatus = Number(this.$route.query.orderContractStatus)
      this.subForm.OrderContractStatus = Number(this.$route.query.orderContractStatus)
    }
    this.getProductNavTypeTree();
    this.getResellerId()
    this.getQiniuToken()
    this.getLogisticsCompany()
    // this.getProvinceList();
  },
  methods: {
    handleOrderContractStatusChange(data) {
      if (data == 10) {
        this.subForm.OrderContractStatus = null
        this.subForm.OrderStatus = 20
      } else {
        this.subForm.OrderContractStatus = data
        this.subForm.OrderStatus = 0
      }
      this.subForm.PageIndex = 1
      this.getSupOrderList()
    },
    getLogisticsCompany(searchKey) {
      setTimeout(() => {
        let data = {
          path: 'ChildOrder/LogisticsCompanyList',
          parmsJson: { searchKey }
        }
        KSAXApiRequest(data).then(res => {
          if (res.data.success) {
            this.logisticsCompanyData = res.data.response.data || []
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }, 1000)
    },
    selectDelivery(data) {
      if (!data.confirmSourceType) return this.$message.error('请先确认货源')
      this.editId = data.childOrderId
      this.operatorId = data.supplierId
      this.logisticsCompanyId = Number(data.confirmLogisticsCode) || null
      this.logisticsCompanyName = data.confirmLogisticsName
      this.deliveryVisible = true
    },
    handleDelivery() {
      let data = {
        path: 'ChildOrder/SetLogisticsInfo',
        parmsJson: {
          id: this.logForm.childOrderId,
          operatorId: this.operatorId,
          confirmLogisticsCode: this.logisticsCompanyId || 0,
          confirmLogisticsName: this.logisticsCompanyName || ''
        }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.$message.success('设置成功')
          this.getSupOrderList()
          this.deliveryVisible = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onLogisticsCompanyChange(data) {
      if (data) {
        let t = this.logisticsCompanyData.find(i => i.id == data)
        this.logisticsCompanyName = t.fullName
      } else {
        this.logisticsCompanyName = null
      }
    },
    confirmSource(data) {
      if (data.confirmSourceType == '库存紧张') {
        this.sourceType = 1
      } else if (data.confirmSourceType == '非自备仓开单') {
        this.sourceType = 2
      } else if (data.confirmSourceType == '自备仓开单') {
        this.sourceType = 3
      } else if (data.confirmSourceType == '无货劝退') {
        this.sourceType = 4
      } else if (data.confirmSourceType == '已开单') {
        this.sourceType = 5
      } else {
        this.sourceType = 2
      }
      // this.sourceValue = this.sourceType == 2 ? data.confirmSourceValue : ''
      this.timeValue = [1].includes(this.sourceType) ? data.confirmSourceValue.split(' ')[0].replace(/\//g, '-') : ''
      this.timeValue1 = [5].includes(this.sourceType) ? data.confirmSourceValue.split(' ')[0].replace(/\//g, '-') : ''
      this.editId = data.childOrderId
      this.operatorId = data.supplierId
      this.orderCreatetime = data.createTime
      this.confirmSourceVisible = true
    },
    handleSetSource() {
      // if (this.sourceType == 2 && !this.sourceValue) {
      //   return this.$message.error('请选择平台')
      // }
      if (([1].includes(this.sourceType) && !this.timeValue) || ([5].includes(this.sourceType) && !this.timeValue1)) {
        return this.$message.error(this.sourceType == 1 ? '请选择预计补货最晚时间' : '请选择预计送达时间')
      }
      let data = {
        id: this.editId,
        operatorId: this.operatorId
      }
      if (this.sourceType == 1) {
        data.confirmSourceType = '库存紧张'
        data.confirmSourceValue = this.timeValue
      }
      if (this.sourceType == 2) {
        data.confirmSourceType = '非自备仓开单'
        // data.confirmSourceValue = this.sourceValue
      }
      if (this.sourceType == 3) {
        data.confirmSourceType = '自备仓开单'
      }
      if (this.sourceType == 4) {
        data.confirmSourceType = '无货劝退'
      }
      if (this.sourceType == 5) {
        data.confirmSourceType = '已开单'
        data.confirmSourceValue = this.timeValue1
      }
      let upData = {
        path: 'ChildOrder/SetSourceInfo',
        parmsJson: data
      }
      KSAXApiRequest(upData).then(res => {
        if (res.data.success) {
          this.$message.success('设置成功')
          this.getSupOrderList()
          this.confirmSourceVisible = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    settlePrice(item) {
      if (item.afterSaleList && item.afterSaleList[0]) {
        return parseFloat(item.skuBillPrice * (item.skuNumber - item.afterSaleList[0].applySkuNumber)).toFixed(2)
      } else {
        return parseFloat(item.skuBillPrice * item.skuNumber).toFixed(2)
      }
    },
    batchTakingOrder() {
      if (!this.multipleTable[0])
        return this.$message.error("请选择需要操作的子订单！");
      let ids = this.multipleTable.map(i => i.childOrderId)
      this.takingOrder(ids)
    },
    takingOrder(ids) {
      let data = {
        path: 'ChildOrder/TakeOrder',
        parmsJson: {
          childOrderIds: Array.isArray(ids) ? ids : [ids]
        }
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.$message.success(res.data.msg)
          this.getSupOrderList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    logisticsInput(e) {
      const regex = /^[a-zA-Z0-9]+$/;
      if (!regex.test(e)) {
        return this.$message.error('只能输入英文字母或数字')
      }
    },
    getLogisticsByNumber(e) {
      let data = {
        path: 'Business_UserManager/GetLogisticsByNumber',
        parms: `code=${this.logForm.logisticsCode}`
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.logForm.logisticsCompanyId = res.data.response.id
        }
      })
    },
    getProductNavTypeTree() {
      let that = this;
      let data = {
        path: 'Product_Type/TreeList'
      }
      KSAXApiRequest(data).then((res) => {
        that.productNavTypeTreeList = res.data.response;
      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    getResellerId() {
      GetAllReseller({ SkipCount: 0, MaxResultCount: 10 }).then(res => {
        if (res.data.success) {
          this.ResellerId = res.data.result.items[0].remoteKey
          this.subForm.SupId = res.data.result.items[0].remoteKey
          this.resellerList = res.data.result.items.map((item) => {
            return {
              value: item.name,
              id: item.remoteKey,
              supType: item.supType
            };
          });
          this.getSupOrderList();
        }
      })
    },
    remoteReseller(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100
      }
      if (key) {
        obj.Name = key;
      }
      return new Promise((resolve, reject) => {
        GetAllReseller(obj).then((res) => {
          this.isShowPage = true;
          // console.log('供应商列表', res);
          if (res.data.success) {
            this.resellerList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.remoteKey,
                supType: item.supType
              };
            });
            // console.log('this.supplierList', this.supplierList)
            resolve(this.resellerList);
          } else {
            this.isShowPage = true;
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    // 修改预售时间
    editPresaleTime(data) {
      this.presaleOrderId = data.childOrderId
      this.presaleDateTime = data.PromoteEndTime
      this.dialogEidtPresaleTime = true
    },
    handleEditPresaleTime() {
      UpdatePresaleTime({
        "childOrderId": this.presaleOrderId,
        "dateTime": this.presaleDateTime
      }).then(res => {
        if (res.data.success) {
          this.$message.success("修改成功！");
          this.getSupOrderList();
          this.dialogEidtPresaleTime = false
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    //获取省
    getTclProvinceList() {
      let params = {
        areaLevel: 1,
      };
      TclAreaList(params).then((res) => {
        this.tclProvinceList = res.data.response.data;
      });
    },
    //获取市
    getTclCityList() {
      let params = {
        areaLevel: 2,
        parentId: this.tclAddresData.tclProvinceId,
      };
      TclAreaList(params).then((res) => {
        this.tclCityList = res.data.response.data;
      });
    },
    //获取区
    getTclAreaList() {
      let params = {
        areaLevel: 3,
        parentId: this.tclAddresData.tclCityId,
      };
      TclAreaList(params).then((res) => {
        this.tclAreaList = res.data.response.data;
      });
    },
    //获取街道
    getTclStreetList() {
      let params = {
        areaLevel: 4,
        parentId: this.tclAddresData.tclCountryId,
      };
      TclAreaList(params).then((res) => {
        this.tclStreetList = res.data.response.data;
      });
    },
    //选择省市区
    handleTclProvince(e) {
      this.tclAddresData.tclProvinceId = e;
      this.tclAddresData.tclCityId = null;
      this.tclAddresData.tclCountryId = null;
      this.tclAddresData.tclStreetId = null;
      this.getTclCityList();
    },
    handleTclCity(e) {
      this.tclAddresData.tclCityId = e;
      this.tclAddresData.tclCountryId = null;
      this.tclAddresData.tclStreetId = null;
      this.getTclAreaList();
    },
    handleTclArea(e) {
      this.tclAddresData.tclCountryId = e;
      this.tclAddresData.tclStreetId = null;
      this.getTclStreetList()
    },
    handleTclStreet(e) {
      this.tclAddresData.tclStreetId = e;
    },
    importEidtAddress() {
      this.dialogEidtAddress = true
    },
    clearBrand() {
      this.subForm.BrandId = null;
    },
    changeCascader() {
      let obj = this.$refs['typeCascader'].getCheckedNodes();
      console.log(obj)
      if (obj.length > 0) {
        //选中
        this.subForm.TypeId = obj[0].value
      } else {
        //清空
        this.subForm.TypeId = null
      }
    },
    handleSelect6(item) {
      console.log('item', item);
      // this.selectBrands.push(item);
      this.subForm.BrandId = item.id;
    },
    async querySearchAsync6(queryString, cb) {
      if (queryString) {
        let res = await this.fetchSupplierList(queryString);
        cb(res);
      } else {
        let res = await this.fetchSupplierList();
        cb(res);
      }
    },
    fetchSupplierList(key) {
      let obj = {
        path: 'Product_Brand/list',
        parmsJson: {
          pageIndex: 1,
          pageSize: 100,
        }
      };
      if (key) {
        obj.parmsJson.brandName = key;
      }
      console.log('obj', obj);
      return new Promise((resolve, reject) => {
        KSAXApiRequest(obj).then((res) => {
          if (res.data.success) {
            this.supplierList = res.data.response.data.map((item) => {
              return {
                value: item.brandName,
                id: item.id,
              };
            });
            resolve(this.supplierList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    getTypeList() {
      productNavTypeTree().then((res) => {
        this.showTypeDialog = true;
        this.typeList = res.data.response;
      });
    },
    // 合伙人列表
    handleSelect5(item) {
      this.subForm.AffiliatedCopartnerId = item.id;
    },
    async querySearchAsync5(queryString, cb) {
      if (queryString) {
        let res = await this.fetchSupplierList5(queryString);
        cb(res);
      } else {
        let res = await this.fetchSupplierList5();
        cb(res);
      }
    },
    fetchSupplierList5(key) {
      let obj = {
        pageIndex: 1,
        pageSize: 100,
      };
      if (key) {
        obj.Name = key;
      }
      return new Promise((resolve, reject) => {
        PartnerList(obj).then((res) => {
          console.log('ressss', res);
          if (res.data.success) {
            this.AffiliatedCopartnerList = res.data.response.data.map((item) => {
              return {
                value: item.Name,
                id: item.Id,
              };
            });
            resolve(this.AffiliatedCopartnerList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync3(queryString, cb) {
      if (queryString) {
        let res = await this.fetchSupplierList3(queryString);
        cb(res);
      } else {
        let res = await this.fetchSupplierList3();
        cb(res);
      }
    },
    //修改物流
    handleRevise(row) {
      console.log('row row', row);
      this.reviseVisible = true;
      let row_one = row.childLogistics && row.childLogistics[0];
      this.reviseForm.orderLogisticsId = row_one.OrderLogisticsId;
      this.reviseForm.sendSkuNumer = row_one.sendSkuNumber;
      this.reviseForm.outChildOrderNo = row_one.OutChildOrderNo
      this.reviseForm.logisticsCode = row_one.logisticsCode
      this.reviseForm.logisticsCompanyId = row_one.LogisticsCompanyId
      logisticsCompanyAllList().then((res) => {
        this.logisticsList1 = res.data.response;
      });
    },
    //修改物流
    handleReviseSubmit() {
      let that = this;
      that
        .$confirm("确认修改, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          reviseLogistics(that.reviseForm).then((res) => {
            if (res.data.success) {
              that.$message.success("修改成功！");
              that.reviseVisible = false;
              that.getSupOrderList();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    },
    async deleteDeli(row) {
      this.$confirm("确认删除物流信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      })
        .then(() => {
          let OrderLogisticsId = row.childLogistics && row.childLogistics[0] && row.childLogistics[0].OrderLogisticsId
          let res = DeleteLogistics({ OrderLogisticsId: OrderLogisticsId });
          if (res.data.success) {
            this.$message.success("修改成功！");
            this.getSupOrderList();
          } else {
            this.$message.error(res.data.msg);
          }
        });

    },
    kplOrder() {
      let that = this
      if (!that.multipleTable[0])
        return that.$message.error("请选择需要操作的子订单！");
      let list = []
      that.multipleTable.forEach(v => {
        if (v.buySupplierName && v.buySupplierName.indexOf('京东开普勒') > -1) {
          list.push(v.childOrderId);
        }
      });
      if (!list.length)
        return that.$message.error("请选择京东开普勒订单！");
      let loadingInstance = Loading.service({ text: '请稍后', background: 'rgba(0,0,0,0.5)' });
      BatchJDOrder({ "childOrderIds": list }).then(res => {
        if (res.data.success) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg)
        }
        loadingInstance.close()
      })
    },
    erpOrder(row) {
      this._tempOrder = row.childOrderNo
      let param = {
        childOrderId: row.childOrderId,
      };
      this.$confirm("确认ERP下单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        KsaxErpOrder(param).then((res) => {
          if (res.data.success) {
            this.$message.success("ERP下单成功！");
            // this.getSupOrderList();
            this.getTargetOrder()
          } else {
            this.$message.error(res.data.msg);
          }
        });
      })
    },
    getTargetOrder() {
      let that = this
      let list = [];
      subOrderList({
        searchType: 1,
        searchKey: this._tempOrder
      }).then((res) => {
        list = res.data.response.data;
        list.forEach((v, i) => {
          if (v.afterSaleCheckStatus == 1 || v.afterSaleCheckStatus == 2 || v.status == 10 || v.status == 60 || v.status == 70) {
            v.isShowBtn = false;
          } else {
            v.isShowBtn = true
          }
        });
        let index = that.orderList.findIndex(i => i.childOrderNo == this._tempOrder)
        this.orderList.splice(index, 1, list[0])
      });
    },
    batchErpOrder() {
      if (!this.multipleTable[0]) {
        return this.$message.error("请选择需要操作的订单！");
      }
      let useOrder = this.multipleTable.filter(i => {
        return i.childOrderThirdType == 13 && !i.childOrderThirdId && i.status == 20
      })
      if (!useOrder.length) {
        return this.$message.error("请选择可以进行ERP下单的订单！");
      }
      let loadingInstance = Loading.service({ text: '请稍后', background: 'rgba(0,0,0,0.5)' });
      BatchERPBackOrder({ childOrderIds: useOrder.map(i => i.childOrderId) }).then(res => {
        if (res.data.success) {
          this.$message.success(res.data.msg);
        } else {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: res.data.msg,
            type: 'error'
          })
        }
        this.getSupOrderList();
        loadingInstance.close()
      })
    },
    // 海信，奥克斯，美的订单重新推送
    sendOrderAgain() {
      let that = this;
      let text = ''
      if (this.sendType == 1) {
        text = '海信'
      } else if (this.sendType == 2) {
        text = '奥克斯'
      } else if (this.sendType == 3) {
        text = '美的'
      } else if (this.sendType == 4) {
        text = '苏宁有货'
      } else if (this.sendType == 7) {
        text = '美的速速销'
      } else if (this.sendType == 8) {
        text = '美的速速销商品'
      }
      this.$confirm(`推送前请确认${text}已取消老订单?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      })
        .then(async () => {
          that.sendLoading = true;
          let res
          if (this.sendType == 1) {
            res = await ReHxSendOrder({ childOrderId: that.sendMsgId });
          } else if (this.sendType == 2) {
            res = await ReAuxSendOrder({ childOrderId: that.sendMsgId });
          } else if (this.sendType == 3) {
            res = await ReMideaSendOrder({ childOrderId: that.sendMsgId });
          } else if (this.sendType == 4) {
            res = await ReSNYHSendOrder({ childOrderId: that.sendMsgId });
          } else if (this.sendType == 7) {
            res = await ReMideaSendOrder_SSX({ childOrderId: that.sendMsgId });
          } else if (this.sendType == 8) {
            res = await ReMideaSendOrder_SSXAC({ childOrderId: that.sendMsgId });
          }
          if (res.data.success) {
            that.$message.success(res.data.msg || '重新推送成功');
            that.refreshDating(this.reSendData);
          } else {
            that.$message.error(res.data.msg || '执行失败');
            that.sendLoading = false;
          }
        })
        .catch(() => {
        });

    },
    // 海信,奥克斯,美的推送  取消
    hideSendWin() {
      this.isSendWinShow = false;
      this.sendMsgId = null;
      this.sendDatas = {}
    },
    // 海信,奥克斯,美的推送  提交
    async handleSendOk() {
      let res
      if (this.sendType == 1) {
        res = await HxTaskSendOrder({ childOrderId: this.sendMsgId });
      } else if (this.sendType == 2) {
        res = await AuxTaskSendOrder({ childOrderId: this.sendMsgId });
      } else if (this.sendType == 3) {
        res = await MideaTaskSendOrder({ childOrderId: this.sendMsgId });
      } else if (this.sendType == 4) {
        res = await SNYHTaskSendOrder({ childOrderId: this.sendMsgId });
      } else if (this.sendType == 5) {
        res = await ANNTOTaskSendOrder({ childOrderId: this.sendMsgId })
      } else if (this.sendType == 6) {
        this.tclAddresData.childOrderId = this.sendMsgId
        res = await ReTCLTaskSendOrder(this.tclAddresData)
      } else if (this.sendType == 7) {
        res = await MideaTaskSendOrder_SSX({ childOrderId: this.sendMsgId })
      } else if (this.sendType == 8) {
        res = await MideaTaskSendOrder_SSXAC({ childOrderId: this.sendMsgId })
      }
      if (res.data.success) {
        this.$message.success(res.data.msg || '执行成功');
        this.isSendWinShow = false;
        this.getSupOrderList()
      } else {
        this.$message.error(res.data.msg || '执行失败');
      }
    },
    async refreshDating(row) {
      this.sendMsgId = row.childOrderId;
      let params = { childOrderId: row.childOrderId };
      let res
      if (this.sendType == 1) {
        res = await GetHxRecordInfo(params);
      } else if (this.sendType == 2) {
        res = await GetAuxRecordInfo(params);
      } else if (this.sendType == 3) {
        res = await GetMideaRecordInfo(params);
      } else if (this.sendType == 4) {
        res = await GetSNYHRecordInfo(params);
      } else if (this.sendType == 5) {
        res = await GetANNTORecordInfo(params)
      } else if (this.sendType == 6) {
        res = await GetTCLRecordInfo(params)
      } else if (this.sendType == 7) {
        res = await GetMideaRecordInfo_SSX(params)
      } else if (this.sendType == 8) {
        res = await GetMideaRecordInfo_SSXAC(params)
      }
      if (!res.data.success) {
        this.$message.error(res.data.msg || '获取更新信息失败,请重试');
        this.sendLoading = false;
      }
      if (!res.data && !res.data.response && !res.data.response.IsSend) {
        return this.$message.error('暂无推送信息');
        this.sendLoading = false;
      }
      this.sendDatas = res.data.response;
      this.sendLoading = false;
      this.$message.success(res.data.msg || '获取更新信息成功');

    },
    // 海信推送
    async sendHxMessage(row) {
      this.sendType = 1
      this.reSendData = row;
      this.sendMsgId = row.childOrderId;
      let params = { childOrderId: row.childOrderId };
      let res = await GetHxRecordInfo(params);
      if (!res.data.success) {
        this.$message.error(res.data.msg || '获取信息失败,请重试');
      }
      if (!res.data && !res.data.response && !res.data.response.IsSend) {
        return this.$message.error('暂无推送信息')
      }
      this.sendDatas = res.data.response;
      this.isSendWinShow = true;
    },
    // 奥克斯推送
    async sendAuxMessage(row) {
      this.sendType = 2
      this.reSendData = row;
      this.sendMsgId = row.childOrderId;
      let params = { childOrderId: row.childOrderId };
      let res = await GetAuxRecordInfo(params);
      if (!res.data.success) {
        this.$message.error(res.data.msg || '获取信息失败,请重试');
      }
      if (!res.data && !res.data.response && !res.data.response.IsSend) {
        return this.$message.error('暂无推送信息')
      }
      this.sendDatas = res.data.response;
      this.isSendWinShow = true;
    },
    // 美的推送
    async sendMediaMessage(row) {
      this.sendType = 3
      this.reSendData = row;
      this.sendMsgId = row.childOrderId;
      let params = { childOrderId: row.childOrderId };
      let res = await GetMideaRecordInfo(params);
      if (!res.data.success) {
        this.$message.error(res.data.msg || '获取信息失败,请重试');
      }
      if (!res.data && !res.data.response && !res.data.response.IsSend) {
        return this.$message.error('暂无推送信息')
      }
      this.sendDatas = res.data.response;
      this.isSendWinShow = true;
    },
    // 美的速速销推送
    async sendSSxMediaMessage(row) {
      this.sendType = 7
      this.reSendData = row;
      this.sendMsgId = row.childOrderId;
      let params = { childOrderId: row.childOrderId };
      let res = await GetMideaRecordInfo_SSX(params);
      if (!res.data.success) {
        this.$message.error(res.data.msg || '获取信息失败,请重试');
      }
      if (!res.data && !res.data.response && !res.data.response.IsSend) {
        return this.$message.error('暂无推送信息')
      }
      this.sendDatas = res.data.response;
      this.isSendWinShow = true;
    },
    // 美的速速销空调推送
    async sendSSxACMediaMessage(row) {
      this.sendType = 8
      this.reSendData = row;
      this.sendMsgId = row.childOrderId;
      let params = { childOrderId: row.childOrderId };
      let res = await GetMideaRecordInfo_SSXAC(params);
      if (!res.data.success) {
        this.$message.error(res.data.msg || '获取信息失败,请重试');
      }
      if (!res.data && !res.data.response && !res.data.response.IsSend) {
        return this.$message.error('暂无推送信息')
      }
      this.sendDatas = res.data.response;
      this.isSendWinShow = true;
    },
    // 苏宁有货推送
    async sendSNYHMessage(row) {
      this.sendType = 4
      this.reSendData = row;
      this.sendMsgId = row.childOrderId;
      let params = { childOrderId: row.childOrderId };
      let res = await GetSNYHRecordInfo(params);
      if (!res.data.success) {
        this.$message.error(res.data.msg || '获取信息失败,请重试');
      }
      if (!res.data && !res.data.response && !res.data.response.IsSend) {
        return this.$message.error('暂无推送信息')
      }
      this.sendDatas = res.data.response;
      this.isSendWinShow = true;
    },
    // 安得物流推送
    async sendADWLMessage(row) {
      this.sendType = 5
      this.reSendData = row;
      this.sendMsgId = row.childOrderId;
      let params = { childOrderId: row.childOrderId };
      let res = await GetANNTORecordInfo(params);
      if (!res.data.success) {
        this.$message.error(res.data.msg || '获取信息失败,请重试');
      }
      if (!res.data && !res.data.response && !res.data.response.IsSend) {
        return this.$message.error('暂无推送信息')
      }
      this.sendDatas = res.data.response;
      this.isSendWinShow = true;
    },
    // TCL推送
    async sendTCLMessage(row) {
      this.sendType = 6
      this.reSendData = row;
      this.tclAddresData.ksaxProvinceId = row.receiverProvinceId
      this.tclAddresData.ksaxCityId = row.receiverCityId
      this.tclAddresData.ksaxCountryId = row.receiverDistrictId
      this.tclAddresData.ksaxStreetId = row.receiverStreetId
      this.sendMsgId = row.childOrderId;
      let params = { childOrderId: row.childOrderId };
      let res = await GetTCLRecordInfo(params);
      if (!res.data.success) {
        this.$message.error(res.data.msg || '获取信息失败,请重试');
      }
      if (!res.data && !res.data.response && !res.data.response.IsSend) {
        return this.$message.error('暂无推送信息')
      }
      this.sendDatas = res.data.response;
      this.isSendWinShow = true;
      this.getTclProvinceList()
    },
    synchronouBtn() {
      GetMeidiOrder().then(res => {
        this.$message.success('操作成功！')
      })
    },
    watchInput(val) {
      if (val <= 0) {
        this.logForm.sendSkuNumber = 1;
      } else if (val > this.tempData.canSendNumber) {
        this.logForm.sendSkuNumber = this.tempData.canSendNumber;
      }
    },
    setCellStyle({ row, column, rowIndex, columnIndex }) {
      // console.log(row, column, rowIndex, columnIndex)
      if (columnIndex === 12) {
        return "buyStyle";
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log(row, column, rowIndex, columnIndex)
      // if (columnIndex === 2) {
      //   return [1, 4];
      // } else if (columnIndex === 3) {
      //   return [0, 0];
      // } else if (columnIndex === 4) {
      //   return [0, 0];
      // } else if (columnIndex === 5) {
      //   return [0, 0];
      // }
    },
    fahuo(row, pRow) {
      if (row.oldId) {
        return this.$message.error("补单订单，无需发货");
      }
      if (!pRow.confirmSourceType) {
        this.$confirm('该订单未确认货源，无法进行发货，请先确认货源！', '提示', {
          confirmButtonText: '前往确认货源',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'mConfirmSourceWin'
        }).then(() => {
          this.confirmSource(pRow)
        }).catch(() => { });
      } else {
        this.dialogVisible = true;
        this.tempData.buySupplierName = row.buySupplierName;
        this.tempData.surplusSendNumber = row.surplusSendNumber;
        this.tempData.canSendNumber = row.canSendNumber;
        this.tempData.sendSkuNumber = row.sendSkuNumber;
        this.typeRadio = 1
        this.logisticsCompanyId = Number(pRow.confirmLogisticsCode) || null
        this.logisticsCompanyName = pRow.confirmLogisticsName
        this.logForm = {
          childOrderId: row.childOrderId,
          buySupplierId: row.buySupplierId,
          logisticsCompanyId: null,
          logisticsCode: "",
          sendSkuNumber: null,
          outChildOrderNo: null,
        };
        let data = {
          path: 'LogisticsCompany/AllList',
          parmsJson: {
            SearchKey: ''
          }
        }
        KSAXApiRequest(data).then((res) => {
          this.logisticsList = res.data.response
        });
      }
    },
    handleStar(row) {
      this.$confirm("确认星链下单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        let param = {
          childOrderId: row.childOrderId,
        };
        StarOrder(param).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.getSupOrderList();
          } else {
            if (res.data.response == -1) {
              this.starProvinceCity = `${row.receiverProvinceName}-${row.receiverCityName}-${row.receiverDistrictName}`
              this.starAddresData.childOrderId = row.childOrderId
              this.getStarProvinceList()
              this.dialogStarVisible = true
            } else {
              this.$message.error(res.data.msg);
            }
          }
        });
      });
    },
    reorderStar() {
      let param = {
        childOrderId: this.starAddresData.childOrderId,
        RegionId: this.starAddresData.districtId
      };
      this.dialogStarVisible = false
      StarOrder(param).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg);
          this.getSupOrderList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getSupOrderList() {
      let that = this;
      that.loading = true;
      let list = [];
      // 如果是查询锁单的推单
      if (this.$route.query.LCCWRecordId) {
        that.subForm.LCCWType = 2
        that.subForm.LCCWLockOrderRecordId = this.$route.query.LCCWRecordId
      }
      let data = {
        "path": "ChildOrder/List",
        "parms": "",
        "parmsJson": that.subForm
      }
      KSAXApiRequest(data).then((res) => {
        // subOrderList(that.subForm).then((res) => {
        that.loading = false;
        list = res.data.response.data;
        list.forEach((v, i) => {
          if (v.afterSaleCheckStatus == 1 || v.afterSaleCheckStatus == 2 || v.status == 10 || v.status == 60 || v.status == 70) {
            v.isShowBtn = false;
          } else {
            v.isShowBtn = true
          }
          // if (v.afterSaleCheckStatus == 2 || v.status == 10 || v.status == 60 || v.status == 70) {
          //   v.isShowBtn = false;
          // } else {
          //   v.isShowBtn = true
          // }
        });

        that.orderList = list;
        that.total = res.data.response.dataCount;
      });
    },
    onSubmit() {
      this.subForm.PageIndex = 1;
      this.getSupOrderList();
    },
    onEmpty() {
      this.AffiliatedCopartnerName = '',
        this.subForm = {
          BrandId: null,
          TypeId: null,
          // AffiliatedCopartnerId: null,
          SearchType: 1,
          SearchKey: "",
          ProductName: "",
          ReceiverName: "",
          ReceiverPhone: "",
          UserParentName: "",
          ProductSupplier: "",
          OrderStatus: 0,
          PayType: -1,
          SpuId: null,
          OrderTimeStart: "",
          OrderTimeEnd: "",
          CompleteTimeStart: "",
          CompleteTimeEnd: "",
          PayTimeStart: "",
          PayTimeEnd: "",
          ShipTimeStart: "",
          ShipTimeEnd: "",
          IsExceptional: -1,
          IsHasBuy: -1,
          IsHasLogistics: -1,
          BuySupplier: "",
          Plate: -1,
          RewardType: null,
          IsSeparate: null,
          IsFirstOrder: null,
          UserType: null,
          LogisticsNo: null,
          PageIndex: 1,
          PageSize: 10,
          SupId: this.subForm.SupId,
          UnShipType: null,
          OrderContractStatus: null
        };
      this.value1 = null;
      this.value2 = null;
      this.value3 = null;
      this.value4 = null;
      this.typeIds = null;
      this.supmodelData.name = "";
      this.brandName = "";
      this.getSupOrderList();
    },
    exportBtn() {
      // this.subForm.SupId = this.ResellerId
      let data = {
        path: 'ChildOrder/ExportByList',
        parmsJson: this.subForm
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.$message.success('操作成功，请稍后打开下载中心查看下载结果')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    callFunction(item) {
      this[item.Func](item);
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    //设为异常
    handleAbnormal() {
      let that = this;
      let list = [];
      let childOrderIds = "";
      if (!that.multipleTable[0])
        return that.$message.error("请选择需要操作的子订单！");
      that.multipleTable.forEach((v, i) => {
        if (v.isExceptional) {
          return that.$message.error("所选择包含异常订单，请重新选择！");
        } else {
          list.push(v.childOrderId);
        }
      });
      childOrderIds = list.join(",");
      that
        .$confirm("确认所选订单设为异常吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          let param = {
            childOrderIds: childOrderIds,
          };
          setExceptional(param).then((res) => {
            if (res.data.status == 200) {
              that.$message.success("设置成功！");
              that.getSupOrderList();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    },
    //取消异常
    handleCancel() {
      let that = this;
      let list = [];
      let childOrderIds = "";
      if (!that.multipleTable[0])
        return that.$message.error("请选择需要操作的子订单！");
      that.multipleTable.forEach((v, i) => {
        if (!v.isExceptional) {
          return that.$message.error("所选择包含非异常订单，请重新选择！");
        } else {
          list.push(v.childOrderId);
        }
        childOrderIds = list.join(",");
        that
          .$confirm("确认取消所选订单异常吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false,
            type: "warning",
          })
          .then(() => {
            let param = {
              childOrderIds: childOrderIds,
            };
            cancelExceptional(param).then((res) => {
              if (res.data.status == 200) {
                that.$message.success("取消成功！");
                that.getSupOrderList();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          });
      });
    },
    // 导入采购信息
    handlePurImport() {
      this.purImpVisible = true;
      this.filePur = null;
    },
    updataPur(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.filePur = e.raw;
    },
    removePur() {
      this.filePur = null;
    },
    handleExpSubmit(index) {
      let that = this;
      that.uploading = true;
      if (index == 1) {
        let formData = new window.FormData();
        formData.append("formFile", that.filePur);
        purImport(formData).then((res) => {
          if (res.data.success) {
            that.$message.success(res.data.msg);
            that.uploading = false;
            that.purImpVisible = false;
            that.filePur = null;
            that.getSupOrderList();
          } else {
            that.$message.error(res.data.msg);
            that.uploading = false;
          }
        });
      } else if (index == 2) {
        let formData = new window.FormData();
        formData.append("file", that.fileLog);
        KSAXApiUpload(formData).then((res) => {
          let data = {
            path: 'Order_InvoiceInfo/OrderLogisticsImport',
            parmsJson: res.data.slice(1)
          }
          KSAXApiRequest(data).then(res => {
            that.uploading = false;
            if (res.data.success) {
              if (res.data.response.isSucces) {
                that.$message.success(res.data.msg);
                that.logisticsVisible = false;
                that.fileLog = null;
                that.getSupOrderList();
              } else {
                let text = ""
                res.data.response.integralOptionInfos.forEach(item => {
                  text += `${item.message}<br/>`
                })
                this.$alert(text, '提示', {
                  dangerouslyUseHTMLString: true
                });
              }
              // if (!res.data.response.IsSucces) {
              //   this.dialogMsgVisible = true;
              //   this.msgList = res.data.response.integralOptionInfos;
              // }
            } else {
              that.$message.error(res.data.msg);
              that.uploading = false;
            }
          })
        });
      } else if (index == 4) {
        let formData = new window.FormData();
        formData.append("formFile", that.fileLog);
        ImportUpdateAddress(formData).then((res) => {
          if (res.data.success) {
            that.$message.success(res.data.msg);
            that.uploading = false;
            that.dialogEidtAddress = false;
            that.fileLog = null;
            that.getSupOrderList();
          } else {
            that.$message.error(res.data.msg);
            that.uploading = false;
          }
        });
      }
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    removeLogistics() {
      this.fileLog = null;
    },
    // 批量确认收货
    handleAllConfirm() {
      let that = this;
      let list = [];
      let childOrderIds = "";
      if (!that.multipleTable[0])
        return that.$message.error("请选择需要操作的子订单！");
      that.multipleTable.forEach((v, i) => {
        if (v.status != 30) {
          return that.$message.error(
            "所选择订单包含非未收货订单，请重新选择！"
          );
        } else {
          list.push(v.childOrderId);
        }
        childOrderIds = list.join(",");
        that
          .$confirm("确认订单收货吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false,
            type: "warning",
          })
          .then(() => {
            let param = {
              childOrderIds: childOrderIds,
            };
            receipt(param).then((res) => {
              if (res.data.status == 200) {
                that.$message.success("处理成功！");
                that.getSupOrderList();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          });
      });
    },
    handleDetail(row) {
      this.$router.push(
        `/OrderManagement/SubOrderDetail?orderid=${row.mainOrderId}&supId=${row.supplierId}`
      );
    },
    //查看物流
    handleLogistics(row) {
      if (row.logisticsCompanyName.includes('安得物流')) {
        return window.open(`https://www.annto.com/mobile/order?orderNoFormMain=${row.logisticsCode}`)
      }
      var that = this;
      // if (!row.LogisticsList || row.LogisticsList.length == 0)
      //   return that.$message.error("暂无物流信息");
      that.logVisible = true;
      var params = {
        // orderLogisticsId: row.OrderLogisticsId,
        logisticsCompanyId: row.logisticsCompanyId,
        logisticsCode: row.logisticsCode,
      };
      GetOrderLogisticsKSAX(params).then((res) => {
        if (res.data.success) {
          that.logDescriptionList = res.data.result.data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    handleSend(row) {
      logisticsCompanyAllList().then((res) => {
        this.logisticsList = res.data.response;
      });
      GetShipSupList({
        childOrderId: row.childOrderId,
      }).then((res) => {
        this.gridData = res.data.response;
      });
    },
    handleSendSubmit() {
      let that = this;
      if (this.typeRadio == 1) {
        this.handleDelivery()
      } else {
        const regex = /^[a-zA-Z0-9]+$/;
        if (!regex.test(that.logForm.logisticsCode)) {
          return this.$message.error('物流单号只能输入英文字母或数字')
        }
        that.clickDisabled = true;
        let data = {
          path: 'ChildOrder/ChildSupShip',
          parms: '',
          parmsJson: that.logForm
        }
        KSAXApiRequest(data).then((res) => {
          if (res.data.success) {
            that.clickDisabled = false;
            that.$message.success(res.data.msg);
            that.dialogVisible = false;
            that.getSupOrderList();
          } else {
            that.clickDisabled = false;
            that.$message.error(res.data.msg);
          }
        });
      }
    },
    handleJD(row) {
      let that = this
      // let { href } = this.$router.resolve({
      //   path: `/Order/OrderManagement/JDOrders?ordermainid=${row.MainOrderId}&orderchildid=${row.childOrderId}`,
      // });
      // window.open(href, "_blank");
      let params = {
        childOrderId: row.childOrderId
      }
      that.$confirm("确认京东下单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        // console.log(that.ThirdPlatformType);
        if (RegExp(/京东慧采/).test(row.buySupplierName)) {
          JDOrder(params).then(res => {
            if (res.data.success) {
              that.$message.success(res.data.msg)
            } else {
              that.$message.error(res.data.msg)
            }
          })
        } else if (RegExp(/京东万商/).test(row.buySupplierName)) {
          JDOrderWs(params).then(res => {
            if (res.data.success) {
              that.$message.success(res.data.msg)
            } else {
              that.$message.error(res.data.msg)
            }
          })
        } else if (RegExp(/京东开普勒/).test(row.buySupplierName)) {
          JDCtpOrder(params).then(res => {
            if (res.data.success) {
              that.$message.success(res.data.msg)
            } else {
              that.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    handleLrlz(row) {
      let that = this
      that.$confirm("确认下单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      })
        .then(() => {
          let param = {
            childOrderId: row.childOrderId,
          };
          LrlzOrder(param).then((res) => {
            if (res.data.status == 200) {
              that.$message.success("下单成功！");
              that.getSupOrderList();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    },
    handleConfirm(row) {
      let that = this;
      let childOrderIds = row.childOrderId;
      that
        .$confirm("确认订单收货吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          let param = {
            path: 'ChildOrder/Receipt',
            parms: '',
            parmsJson: {
              childOrderIds: childOrderIds,
            }
          };
          KSAXApiRequest(param).then((res) => {
            if (res.data.status == 200) {
              that.$message.success("收货成功！");
              that.getSupOrderList();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    },
    handleRefund(row) {
      let that = this;
      that.receiveRow = row;
      that.returnForm.childOrderId = row.childOrderId;
      that.returnForm.applySkuId = row.skuId;
      this.needData.childOrderNo = row.childOrderNo;
      this.getBalanceCanRefundNum(row);
    },
    confirmBtn() {
      this.getIsJoinChannelFullReduce();
    },
    watchApplySkuNumber(e) {
      if (e <= 0) {
        this.needData.applySkuNumber = 1;
      } else if (e > this.balanceCanRefundNum) {
        this.needData.applySkuNumber = this.balanceCanRefundNum;
      }
    },
    getBalanceCanRefundNum(val) {
      let data = {
        path: 'AfterSaleOrder/GetBalanceCanRefundNum',
        parms: '',
        parmsJson: {
          childOrderNo: val.childOrderNo
        }
      }
      KSAXApiRequest(data).then((res) => {
        if (res.data.success) {
          if (res.data.response == 0) {
            return this.$message.error("已没有商品可进行退款!");
          }
          this.dialogSkuNumber = true;
          this.balanceCanRefundNum = res.data.response || 1;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getIsJoinChannelFullReduce() {
      let data = {
        path: "AfterSaleOrder/CalculateRefundAmount",
        parms: '',
        parmsJson: this.needData
      }
      KSAXApiRequest(data).then((res) => {
        if (res.data.success) {
          this.dialogSkuNumber = false;
          this.returnVisible = true;
          this.fullReduceData = res.data.response || {};
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // testRefundAmount(e) {
    //   if (e <= 0.01) {
    //     this.returnForm.refundAmount = 0.01;
    //   }
    //   // else if (e > this.receiveRow.Amount) {
    //   //   this.returnForm.refundAmount = this.receiveRow.Amount;
    //   // }
    // },
    handleReturnSubmit() {
      let that = this;
      // if (that.returnForm.refundAmount == 0)
      //   return that.$message.error("退款金额不能为零！");
      if (!that.returnForm.reason) return that.$message.error("请输入备注！");
      that
        .$confirm("确认退款？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          this.returnForm.applySkuNumber = this.fullReduceData.applySkuNumber;
          this.returnForm.refundAmount = this.fullReduceData.actualRefundAmount
          let data = {
            path: 'AfterSaleOrder/ApplyRefund',
            parms: '',
            parmsJson: that.returnForm
          }
          KSAXApiRequest(data).then((res) => {
            if (res.data.success) {
              that.$message.success("提交成功！");
              that.returnVisible = false;
              that.getSupOrderList();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    },
    handlePushJHOrder(row) {
      let param = {
        childOrderId: row.childOrderId,
      };
      PushJHOrder(param).then((res) => {
        if (res.data.status == 200) {
          that.$message.success("下单成功！");
          that.getSupOrderList();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    handlePicker1(e) {
      if (e) {
        this.subForm.OrderTimeStart = e[0];
        this.subForm.OrderTimeEnd = e[1];
      } else {
        this.subForm.OrderTimeStart = null;
        this.subForm.OrderTimeEnd = null;
      }
    },
    handlePicker2(e) {
      if (e) {
        this.subForm.CompleteTimeStart = e[0];
        this.subForm.CompleteTimeEnd = e[1];
      } else {
        this.subForm.CompleteTimeStart = null;
        this.subForm.CompleteTimeEnd = null;
      }
    },
    handlePicker3(e) {
      if (e) {
        this.subForm.ShipTimeStart = e[0];
        this.subForm.ShipTimeEnd = e[1];
      } else {
        this.subForm.ShipTimeStart = null;
        this.subForm.ShipTimeEnd = null;
      }
    },
    handlePicker4(e) {
      if (e) {
        this.subForm.PayTimeStart = e[0];
        this.subForm.PayTimeEnd = e[1];
      } else {
        this.subForm.PayTimeStart = null;
        this.subForm.PayTimeEnd = null;
      }
    },
    handleCurrentChange(val) {
      this.subForm.PageIndex = val;
      this.getSupOrderList();
    },
    handleSizeChange(e) {
      this.subForm.PageSize = e;
      this.getSupOrderList();
    },
    handleExp() {
      let that = this;
      let data = that.subForm
      data.IsHiddenReceiverInfo = true
      childListExport(data).then((res) => {
        if (res.data.success) {
          that.$message.success("操作成功，请稍后打开下载中心查看下载结果");
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    settlementExport() {
      let that = this;
      let data = that.subForm
      data.IsHiddenReceiverInfo = true
      ChildOrderExportFinanceList(data).then((res) => {
        if (res.data.success) {
          that.$message.success("操作成功，请稍后打开下载中心查看下载结果");
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    handleHiddenExp() {
      let that = this;
      let data = that.subForm
      data.AdminIdentity = 1
      // data.IsHiddenReceiverInfo = false
      childListExport(data).then((res) => {
        if (res.data.success) {
          that.$message.success("操作成功，请稍后打开下载中心查看下载结果");
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    retailExport() {
      let that = this;
      let data = that.subForm
      data.AdminIdentity = 1
      // data.IsHiddenReceiverInfo = false
      RetailExportList(data).then((res) => {
        if (res.data.success) {
          that.$message.success("操作成功，请稍后打开下载中心查看下载结果");
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    handleHiddenExp2() {
      let that = this;
      let data = that.subForm
      data.AdminIdentity = 2
      // data.IsHiddenReceiverInfo = false
      childListExport(data).then((res) => {
        if (res.data.success) {
          that.$message.success("操作成功，请稍后打开下载中心查看下载结果");
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    operateExport() {
      let that = this;
      operateExport(that.subForm).then((res) => {
        if (res.data.success) {
          that.$message.success("操作成功，请稍后打开下载中心查看下载结果");
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    handleImport() {
      this.logisticsVisible = true;
      this.fileLog = null;
    },
    handleImportBatch() {
      this.approveBatch = true
      this.fileApprove = null
    },
    approveClose() {
      this.fileApprove = null
      this.approveBatch = false
    },
    updataApprove(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileApprove = e.raw;
    },
    removeApprove() {
      this.fileApprove = null
    },
    approveSure() {
      this.uploading = true;
      let formData = new window.FormData();
      formData.append("formFile", this.fileApprove);
      ImportApplyRefund(formData).then((res) => {
        this.uploading = false
        if (res.data.success) {
          this.$message.success(res.data.msg);
          this.approveClose()
          this.getSupOrderList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    upDataInfo(index) {
      if (index == 1) {
        window.open(
          "https://qiniuimage.kuaishouaxiu.com/%E4%BF%A1%E6%81%AF%E9%87%87%E8%B4%AD%E6%A8%A1%E6%9D%BF.xlsx?v1"
        );
      } else if (index == 2) {
        window.open(
          // "https://homeimage.ksaxshop.com/erp%E7%89%A9%E6%B5%81%E6%A8%A1%E6%9D%BF1.xlsx"
          "https://ksaximg.ksaxshop.com/erp/erp%E7%89%A9%E6%B5%81%E6%A8%A1%E6%9D%BF1%281%29.xlsx"
        );
      } else if (index == 3) {
        window.open(
          "https://homeimage.ksaxshop.com/%E5%AF%BC%E5%85%A5%E6%89%B9%E9%87%8F%E7%94%B3%E8%AF%B7%E9%80%80%E6%AC%BE%E6%A8%A1%E6%9D%BF.xlsx"
        );
      } else if (index == 4) {
        window.open("https://homeimage.ksaxshop.com/%E6%89%B9%E9%87%8F%E4%BF%AE%E6%94%B9%E8%AE%A2%E5%8D%95%E6%94%B6%E8%B4%A7%E5%9C%B0%E5%9D%80%E6%A8%A1%E6%9D%BF.xlsx")
      }
    },
    handleSetAddress(row) {
      this.getReceiverAddressOrderInfo(row.childOrderId);
    },
    handleAllSetAddress() {
      let list = [];
      if (!this.multipleTable[0])
        return this.$message.error("请选择需要操作的子订单！");
      for (let i = 0; i < this.multipleTable.length; i++) {
        if (this.multipleTable[i].status > 30) {
          return this.$message.error(`第${i + 1}条订单无法修改收货信息`);
        } else {
          list.push(this.multipleTable[i].childOrderId);
        }
      }
      this.getReceiverAddressOrderInfo(list.join(","));
    },
    getReceiverAddressOrderInfo(str) {
      var data = {
        ids: str,
      };
      GetModifyReceiverAddressOrderInfo(data).then((res) => {
        if (res.data.success) {
          this.addressShowDialog = true;
          var data = {
            phone: "",
            name: "",
            provinceName: "",
            cityName: "",
            districtName: "",
            streetName: "",
            address: "",
            provinceId: null,
            cityId: null,
            districtId: null,
            streetId: null,
          },
            list = [];
          res.data.response.forEach((v, i) => {
            list[i] = { ...v, ...data };
          });
          this.addressList = list;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleCopy(scope) {
      const index = scope.$index,
        row = scope.row;
      this.addressList[index].phone = row.receiverPhone;
      this.addressList[index].name = row.receiverName;
      this.addressList[index].provinceName = row.receiverProvinceName;
      this.addressList[index].cityName = row.receiverCityName;
      this.addressList[index].districtName = row.receiverDistrictName;
      this.addressList[index].streetName = row.receiverStreetName;
      this.addressList[index].provinceId = row.receiverProvinceId;
      this.addressList[index].cityId = row.receiverCityId;
      this.addressList[index].districtId = row.receiverDistrictId;
      this.addressList[index].streetId = row.receiverStreetId;
      this.addressList[index].address = row.receiverAddress;
      this.getCityList(index);
      this.getAreaList(index);
      this.getStreetList(index);
    },
    //获取省
    getProvinceList() {
      let params = {
        areaLevel: 1,
      };
      areaList(params).then((res) => {
        this.provinceList = res.data.response.data;
      });
    },
    //获取市
    getCityList(index) {
      let params = {
        areaLevel: 2,
        parentId: this.addressList[index].provinceId,
      };
      areaList(params).then((res) => {
        this.cityList = res.data.response.data;
      });
    },
    //获取区
    getAreaList(index) {
      let params = {
        areaLevel: 3,
        parentId: this.addressList[index].cityId,
      };
      areaList(params).then((res) => {
        this.areaList = res.data.response.data;
      });
    },
    //获取街道
    getStreetList(index) {
      let params = {
        areaLevel: 4,
        parentId: this.addressList[index].districtId,
      };
      areaList(params).then((res) => {
        this.streetList = res.data.response.data;
      });
    },
    //选择省市区
    handleProvince(e, scope) {
      var index = scope.$index;
      this.addressList[index].provinceId = e;
      this.addressList[index].cityId = null;
      this.addressList[index].districtId = null;
      this.addressList[index].streetId = null;
      this.addressList[index].cityName = null;
      this.addressList[index].districtName = null;
      this.addressList[index].streetName = null;
      this.getCityList(index);
    },
    handleCity(e, scope) {
      var index = scope.$index;
      this.addressList[index].cityId = e;
      this.addressList[index].districtId = null;
      this.addressList[index].streetId = null;
      this.addressList[index].districtName = null;
      this.addressList[index].streetName = null;
      this.getAreaList(index);
    },
    handleArea(e, scope) {
      var index = scope.$index;
      this.addressList[index].districtId = e;
      this.addressList[index].streetId = null;
      this.addressList[index].streetName = null;
      this.getStreetList(index);
    },
    handleStreet(e, scope) {
      var index = scope.$index;
      this.addressList[index].streetId = e;
    },
    //获取省
    getStarProvinceList() {
      let params = {
        areaLevel: 1,
      };
      AreaStarList(params).then((res) => {
        this.starProvinceList = res.data.response.data;
      });
    },
    //获取市
    getStarCityList() {
      let params = {
        areaLevel: 2,
        parentId: this.starAddresData.provinceId,
      };
      AreaStarList(params).then((res) => {
        this.starCityList = res.data.response.data;
      });
    },
    //获取区
    getStarAreaList() {
      let params = {
        areaLevel: 3,
        parentId: this.starAddresData.cityId,
      };
      AreaStarList(params).then((res) => {
        this.starAreaList = res.data.response.data;
      });
    },
    //选择省市区
    handleStarProvince(e) {
      this.starAddresData.provinceId = e;
      this.starAddresData.cityId = null;
      this.starAddresData.districtId = null;
      this.getStarCityList();
    },
    handleStarCity(e) {
      this.starAddresData.cityId = e;
      this.starAddresData.districtId = null;
      this.getStarAreaList();
    },
    handleStarArea(e) {
      this.starAddresData.districtId = e;
    },
    handleConfirmBtn() {
      var list = [];
      for (let i = 0; i < this.addressList.length; i++) {
        debugger;
        if (
          !this.addressList[i].provinceId ||
          !this.addressList[i].cityId ||
          !this.addressList[i].districtId ||
          !this.addressList[i].streetId ||
          !this.addressList[i].address
        ) {
          return this.$message.error(`请完善${i + 1}条订单`);
        } else {
          list.push({
            childOrderId: this.addressList[i].childOrderId,
            receiverName: this.addressList[i].name,
            receiverPhone: this.addressList[i].phone,
            receiverProvinceId: this.addressList[i].provinceId,
            receiverCityId: this.addressList[i].cityId,
            receiverDistrictId: this.addressList[i].districtId,
            receiverStreetId: this.addressList[i].streetId,
            address: this.addressList[i].address,
          });
        }
      }
      ModifyReceiverAddress(list).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg);
          this.addressShowDialog = false;
          this.getSupOrderList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    bindThireadOrder() {
      if (this.multipleTable.length < 1) {
        return this.$message.error('请选择订单');
      }
      if (this.multipleTable.length > 1) {
        return this.$message.error('请选择一条订单');
      }
      this.BindThireadOrderDialog = true;
      this.ThreadOrderForm.ThirdType = null;
      this.ThreadOrderForm.ThirdOrderId = null;
    },
    submitBindThireadOrder() {
      if (!this.ThreadOrderForm.ThirdType) {
        return this.$message.error('请选择类型');
      }
      if (!this.ThreadOrderForm.ThirdOrderId) {
        return this.$message.error('请输入外部订单号');
      }
      this.ThreadOrderForm.childOrderId = parseInt(this.multipleTable[0].childOrderId);
      let that = this;
      BindThireadOrderInfo(that.ThreadOrderForm).then((res) => {
        if (res.data.success) {
          that.getSupOrderList();
          this.BindThireadOrderDialog = false;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    handleOrderType(e) {
      this.ThreadOrderForm.ThirdType = e;
    },
    batchRefund() {
      if (this.multipleTable.length < 1) {
        return this.$message.error('请选择订单');
      } else {
        this.loading = true
        BatchRefundStatistics({
          childOrderIds: this.multipleTable.map(i => i.childOrderId).join()
        }).then(res => {
          this.loading = false
          this.$confirm(`
          <p class="confirm-p">提示：  ${res.data.msg}</p>
          <p>已选订单： ${res.data.response.OrderNum}</p>
          <p>商品数量：  ${res.data.response.applySkuNumber}</p>
          <p>退款合计：  ¥${res.data.response.RefundAmount}</p>
        `, '确定批量退款', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true
          }).then(() => {
            this.loading = true
            BatchApplyRefund({
              childOrderIds: this.multipleTable.map(i => i.childOrderId).join()
            }).then(res => {
              this.loading = false
              if (res.data.success) {
                this.$message.success(res.data.msg);
                this.getSupOrderList()
              } else {
                this.$message.error(res.data.msg);
              }
            })
          }).catch(() => {

          });
        })
      }
    },
    exchangePick(row) {
      const h = this.$createElement;
      this.$prompt('', 'skuId', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '请输入skuId',
        message: h('p', null, [
          h('span', null, '注意是 '),
          h('i', { style: 'color: red' }, 'skuId '),
          h('span', null, ' 而不是spuId'),
        ]),
      }).then(({ value }) => {
        SwitchPurchaseSup({
          "skuId": value,
          "childOrderId": row.childOrderId
        }).then(res => {
          if (res.data.success) {
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        })
      }).catch(() => {

      });
    },
    handlRemark(row) {
      this.row = row
      this.UploadFileUrl = [];
      this.remarkForm = {
        MainOrderId: row.mainOrderId,
        ChildOrderId: row.childOrderId,
        OperatorId: row.supplierId,
        Description: "",
        Images: ""
      }
      let data = {
        path: "ChildOrderTrack/ErpMarkList",
        parms: '',
        parmsJson: {
          ChildId: this.row.childOrderId,
          OperatorId: this.row.supplierId
        }
      }
      KSAXApiRequest(data).then((res) => {
        if (res.data.success) {
          this.remarkTableData = res.data.response
          this.remarkTableData.forEach(item => {
            item.images = item.images ? item.images.split(",") : []
          })
          this.remarkVisible = true
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    remarkClose() {
      this.remarkVisible = false
    },
    remarkConfirm() {
      if (!this.remarkForm.Description && this.UploadFileUrl.length === 0) {
        return this.$message.warning("请填写备注信息或上传图片");
      }
      this.remarkForm.Images = this.UploadFileUrl.join(',') || '';
      let data = {
        path: "ChildOrderTrack/ErpAddMark",
        parms: '',
        parmsJson: this.remarkForm
      }
      KSAXApiRequest(data).then((res) => {
        if (res.data.success) {
          this.$message.success("提交成功");
          this.remarkClose()
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleBusinessPic(file) { // 上传图片
      if (this.UploadFileUrl.length >= 5) {
        return this.$message.warning("最多上传5张图片");
      }
      let that = this;
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.png`,
        token: this.qiniuToken
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then(res => {
          this.UploadFileUrl.push(res);
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    handleDelPic(index) { // 删除图片
      this.UploadFileUrl.splice(index, 1);
    },
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
        .catch(() => {
        });
    },
    getSkuNumber(row) {
      let applySkuNumber = 0
      row.afterSaleList.forEach(item => {
        if (item.refundStatus === 1) {
          applySkuNumber = applySkuNumber + item.applySkuNumber
        }
      })
      return row.skuNumber + (applySkuNumber ? `(已退款：${applySkuNumber})` : "")
    },
    handleImgClose() {
      this.$nextTick(() => {
        let domImageView = document.querySelector(".el-image-viewer__mask"); // 获取遮罩层dom
        if (!domImageView) {
          return;
        }
        domImageView.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      })
    },
  },
  mounted() {
    let that = this;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    buttonList.forEach((v) => {
      if (v.Func == "editPresaleTime") {
        that.isEditPresaleTime = true;
      }
      if (v.Func == "handleSend") {
        that.isShowSend = true;
      }
      if (v.Func == "handleConfirm") {
        that.isShowConfirm = true;
      }
      if (v.Func == "handleRefund") {
        that.isShowRefund = true;
      }
      if (v.Func == "handleDetail") {
        that.isShowDetail = true;
      }
      if (v.Func == "handleJD") {
        that.isShowJD = true;
      }
      if (v.Func == "handleStar") {
        that.isShowStar = true;
      }
      if (v.Func == "handleSetAddress") {
        that.isShowSetAddress = true;
      }
      if (v.Func == "sendMessage") {
        that.authHaiXin = true;
      }
      if (v.Func == "sendAuxMessage") {
        that.authAux = true;
      }
      if (v.Func == "sendMediaMessage") {
        that.authMedia = true;
      }
      if (v.Func == "sendMediaSSXMessage") {
        that.authMediaSSX = true
      }
      if (v.Func == "sendMediaSSXACMessage") {
        that.authMediaSSXAC = true
      }
      if (v.Func == "sendSNYHMessage") {
        that.authSNYH = true;
      }
      if (v.Func == "sendADWLMessage") {
        that.authADWL = true;
      }
      if (v.Func == "sendTCLMessage") {
        that.authTCL = true;
      }
      if (v.Func == "exchangePick") {
        that.isExchangePick = true;
      }
      if (v.Func == "handleLrlz") {
        that.isShowLrlz = true;
      }
      if (v.Func == "deliveryDelete") {
        that.isDeliveryDelete = true;
      }
      if (v.Func == "deliveryEdit") {
        that.isDeliveryEdit = true;
      }
    });
    const toolBarButtonList = buttonList.filter((item) => {
      return item.ButtonType === 10 && item.Func;
    });
    this.buttonList_toolBar = toolBarButtonList;
    const tableButtonList = buttonList.filter((item) => {
      return item.ButtonType === 20 && item.Func;
    });

    const tableButtonList1 = buttonList.filter((item) => {
      return item.ButtonType === 20;
    });

    this.buttonList_table = tableButtonList;
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/Order/OrderManagement/OrderDetail") {
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next();
  },
};
</script>

<style scoped>
.main_order {
  padding-left: 20px;
}

.main_order .el-form-box {
  padding: 20px 20px 0;
  background: #ebeef5;
}

.el-form-box>>>.el-form-item {
  margin-bottom: 10px;
}

.el-form-box>>>.el-input__inner,
.el-autocomplete,
.el-select {
  width: 100%;
}

.tool_box {
  padding-top: 20px;
  overflow: hidden;
}

.info_row {
  display: flex;
  justify-content: center;
  align-items: center;
}

.info_row>p {
  flex: 1;
  text-align: left;
}

.add_weight {
  font-weight: 600;
}

.co-gray {
  color: #999;
}

.good_detail {
  display: flex;
  justify-content: center;
  align-items: center;
}

.good_detail img {
  width: 80px;
  display: block;
  border: 2px solid #666;
  border-radius: 10px;
}

.good_title {
  margin-left: 10px;
  flex: 1;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  white-space: pre-line;
  display: -webkit-box;
  text-align: left;
}

.item_li {
  border-bottom: 1px solid #eee;
  padding: 10px;
  font-size: 20px;
}

.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* .el-input {
  width: 300px;
} */

.logStyle {
  color: #409eff;
  cursor: pointer;
}

/deep/ .orderDialog .el-dialog {
  background: #F8FAFB;
}

/deep/ .orderDialog .el-dialog .el-radio {
  line-height: inherit;
}
</style>
<style>
.buyStyle {
  padding: 0 !important;
}

.buyStyle .cell {
  padding: 0 !important;
}

#hxSend .el-form-item {
  margin-bottom: 0px;
}

.confirm-p {
  word-wrap: break-word;
  word-break: break-all;
}

.img_box1 {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  position: relative;
  margin-right: 10px;
}

.img_box1 img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.del_box {
  position: absolute;
  top: -15px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.explain {
  margin-top: 15px;
  color: #606266;
  padding: 15px;
  background: #f1f1f1;
  border-radius: 15px;
  font-size: 14px
}

.explain-btn {
  color: #409EFF !important;
  background: #ecf5ff !important;
  border-color: #b3d8ff !important;
}
</style>
